import { normalizeText } from "../../../utils";
import {
  ALL_PAYMENT_SITUATIONS,
  type PaymentListItem,
  type PaymentSituation,
} from "./paymentListTypes";

export const getAnoRequestParam = (
  year: number | null | undefined,
): number => {
  if (year === null || year === undefined) return 2026;
  const n = Number(year);
  return Number.isFinite(n) && n > 0 ? n : 2026;
};

export function parseSolicitacaoNumero(
  value: number | string | null | undefined,
): number {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string") {
    const m = value.match(/(\d+)/);
    if (m) return Number(m[1]);
  }
  return 0;
}

export function resolveSituacaoPagamento(
  situacao:
    | { id?: number | null; nome?: string | null }
    | string
    | null
    | undefined,
): PaymentSituation {
  const nome =
    typeof situacao === "string"
      ? situacao
      : String(situacao?.nome ?? "").trim();
  const k = normalizeText(nome);

  for (const label of ALL_PAYMENT_SITUATIONS) {
    if (normalizeText(label) === k) return label;
  }

  if (k.includes("assinatura")) return "Assinatura Pendente";
  if (k.includes("programacao")) return "Programação Pendente";
  if (
    k.includes("fusion") ||
    k.includes("aprovacao") ||
    k.includes("pag gerado")
  ) {
    return "Em aprovação no Fusion";
  }
  if (k.includes("provisionado")) return "Pagamento Provisionado";
  if (k.includes("conclu")) return "Pagamento Concluído";

  return (nome || "Programação Pendente") as PaymentSituation;
}

export const formatSolicitacao = (num: number | null | undefined): string => {
  if (num === null || num === undefined) return "-";
  const n = Number(num);
  if (!Number.isFinite(n) || n <= 0) return "-";
  return `${n}ª SOLICITAÇÃO`;
};

export type PaymentActionRule = {
  canView: boolean;
  canProgram: boolean;
  viewReason: string;
  programReason: string;
};

export function getPaymentActionRule(
  item: Pick<PaymentListItem, "situacaoPagamento"> | null | undefined,
): PaymentActionRule {
  const situacao = normalizeText(item?.situacaoPagamento);

  if (situacao === "assinatura pendente") {
    return {
      canView: true,
      canProgram: false,
      viewReason: "Visualizar",
      programReason: "Ação bloqueada: aguardando assinatura do formulário.",
    };
  }

  if (situacao === "programacao pendente" || situacao === "programação pendente") {
    return {
      canView: true,
      canProgram: true,
      viewReason: "Visualizar",
      programReason: "Realizar programação",
    };
  }

  if (
    situacao === "em aprovacao no fusion" ||
    situacao === "pagamento provisionado" ||
    situacao === "pagamento concluido" ||
    situacao === "pagamento concluído"
  ) {
    return {
      canView: true,
      canProgram: false,
      viewReason: "Visualizar",
      programReason: "Programação indisponível para esta situação.",
    };
  }

  return {
    canView: true,
    canProgram: false,
    viewReason: "Visualizar",
    programReason: "Ação indisponível para esta situação.",
  };
}
